import OperatorConsole from "./OperatorConsole";

/** Entry route for /app/bethouse/manage — delegates to the shared console. */
const BetMarketsHub = () => <OperatorConsole />;

export default BetMarketsHub;
